/*
 * Copyright (c) 2018 Bruce Schubert.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import React, {Component} from 'react'
import {observer} from 'mobx-react'
import PropTypes from 'prop-types'
import Globe from '../globe'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Button, Card, CardBody, CardHeader, Collapse} from 'reactstrap'


/**
 * A collapsible Card for showing layer information.
 */
const InformationCard = observer(class InformationCard extends Component {

  static propTypes = {
    title: PropTypes.string,
    icon: PropTypes.string,
    globe: PropTypes.instanceOf(Globe)
  };

  static defaultProps = {
    title: 'Information',
    icon: 'infoCircle',
  };

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
    this.state = {
      isOpen: false
    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  close() {
    this.setState({
      isOpen: false
    })
  }

  render() {

    const layers = this.props.globe && this.props.globe.getEnabledLayers(['data', 'atmosphere']);

    if (layers && layers.length > 0) {
      // TODO: Allow multiple layer information
      const layer = layers[0];

      return (
          <Collapse isOpen={this.state.isOpen}>
            <Card className="globe-card w-100 interactive">
              <CardHeader>
                <h5 className="card-title">
                  <FontAwesomeIcon icon={this.props.icon}/> {layer.displayName}
                  <Button className="close pull-right" aria-label="Close" onClick={this.toggle}>
                    <span aria-hidden="true">&times;</span>
                  </Button>
                </h5>
              </CardHeader>
              <CardBody>
                {layer.getLayerDisplayInformation()}
              </CardBody>
            </Card>
          </Collapse>
      )
    } else {
      return (<Collapse isOpen={this.state.isOpen}>
            <Card className="globe-card w-100 interactive">
              <CardHeader>
                <h5 className="card-title">
                  <FontAwesomeIcon icon={this.props.icon}/> Layer information
                  <Button className="close pull-right" aria-label="Close" onClick={this.toggle}>
                    <span aria-hidden="true">&times;</span>
                  </Button>
                </h5>
              </CardHeader>
              <CardBody>
                You do not have any active layers. Select one to see more information about it.
              </CardBody>
            </Card>
          </Collapse>
      );
    }
  }
});

export default InformationCard
